import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AnnouncementBanner } from "./components/AnnouncementBanner";
import { BottomNav } from "./components/BottomNav";
import { NotificationBanner } from "./components/NotificationBanner";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { ToastProvider } from "./components/Toast";
import { WhatsNewModal } from "./components/WhatsNewModal";
import { AuthProvider, useAuth } from "./lib/auth";

const AgendaPage = lazy(() => import("./pages/AgendaPage"));
const ProfilePage = lazy(() => import("./pages/ProfilePage"));
const SettingsPage = lazy(() => import("./pages/SettingsPage"));
const AdminPage = lazy(() => import("./pages/AdminPage"));
const PrenotaPage = lazy(() => import("./pages/PrenotaPage"));

function PageLoader() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="w-6 h-6 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

function AdminRoute({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  if (user?.role !== "admin") return <Navigate to="/" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <ProtectedRoute>
          <div
            className="pt-14 md:pt-0 md:pb-0 md:pl-56"
            style={{ paddingBottom: "calc(4rem + env(safe-area-inset-bottom))" }}
          >
            <NotificationBanner />
            <AnnouncementBanner />
            <WhatsNewModal />
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<AgendaPage />} />
                <Route path="/dichiara" element={<PrenotaPage />} />
                <Route path="/prenota" element={<Navigate to="/dichiara" replace />} />
                <Route path="/map" element={<Navigate to="/" replace />} />
                <Route path="/bookings" element={<Navigate to="/" replace />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route
                  path="/admin"
                  element={
                    <AdminRoute>
                      <AdminPage />
                    </AdminRoute>
                  }
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Suspense>
          </div>
          <BottomNav />
        </ProtectedRoute>
      </AuthProvider>
    </ToastProvider>
  );
}
